import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataBagService } from 'src/app/common/data-bag.service';
import { DateService } from 'src/app/common/date.service';
import { LoaderService } from 'src/app/common/loader/loader.service';

@Component({
	selector: 'app-group-offer-price-history-dialog',
	templateUrl: './group-offer-price-history-dialog.component.html',
	styleUrls: ['./group-offer-price-history-dialog.component.scss'],
})
export class GroupOfferPriceHistoryDialogComponent implements OnInit {
	constructor(
		protected bag: DataBagService,
		protected date: DateService,
		protected loader: LoaderService,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {}

	disableHTMLClose: boolean;
	columns: string[] = ['publication', 'date', 'price', 'isActive', 'author'];
	dataSource;

	now = new Date();

	ngOnInit() {
		this.loader.show();
		this.bag.get(`/offer/term_price/?term=${this.data.id}`, (result, error) => {
			if (result) {
				this.dataSource = result.results;
				const convertMaxDate = this.findActiveDate();
				this.findWaitingTerms();
				this.dataSource.map((item) => {
					item.dateFrom = this.date.apiToDateTime(item.dateFrom);
					if (convertMaxDate.date == item.dateFrom.date && convertMaxDate.time == item.dateFrom.time) {
						item['isActive'] = 'T';
					}
					item.createdAt = this.date.apiToDateTime(item.createdAt);
				});
			} else throw new Error(JSON.stringify(error.error));
		});
	}

	findActiveDate() {
		const activeTerms = this.dataSource.filter((item) => {
			return new Date(item.dateFrom) <= new Date(this.now);
		});

		const activeDate = new Date(
			Math.max(
				...activeTerms.map((element) => {
					return new Date(element.dateFrom);
				}),
			),
		);
		this.loader.hide();
		return this.date.apiToDateTime(activeDate.toISOString());
	}

	findWaitingTerms() {
		const waitnigTerms = this.dataSource.filter((item) => {
			return new Date(item.dateFrom) > new Date(this.now);
		});

		waitnigTerms.map((element) => {
			element['isActive'] = 'W';
		});
	}
}
